module.exports = __webpack_public_path__ + "static/media/interested-in-course-bg1.54d55385.png";